module.exports = __webpack_public_path__ + "static/media/270963.5ea5d19c.png";